import { render, staticRenderFns } from "./ChangePasswordConsultantModal.vue?vue&type=template&id=07151341&lang=pug&"
import script from "./ChangePasswordConsultantModal.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordConsultantModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports